import { InmarBlindReturnZodArraySchema } from "@redotech/redo-model/integrations/returns/inmar/inmar-blind-return";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getInmarBlindReturns = {
  name: "getInmarBlindReturns" as const,
  input: z.object({
    limit: z.number().min(1).max(100).default(50).optional(),
    offset: z.number().min(0).default(0).optional(),
    pageContinue: z.string().optional(),
    sortKey: z.string().optional(),
    sortDirection: createEnum(["asc", "desc"]).optional(),
  }),

  output: z.object({
    returns: InmarBlindReturnZodArraySchema,
    pageNext: z.string().nullish(),
  }),
};
